'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconFancyA, iconFancyATag } from '@ni/nimble-components/dist/esm/icons/fancy-a';
import { wrap } from '../../utilities/react-wrapper';

export type { IconFancyA };
export { iconFancyATag };
export const NimbleIconFancyA = wrap(IconFancyA);